import React from 'react';

import Box from '@mui/material/Box';

import { ScoreDetails } from 'ff/debrief/models';

import ScoreBreakDown from './ScoreBreakDown';

interface Props {
    segmentLabel: string;
    segmentScore: number;
    scoringDetails: ScoreDetails[];
}

const ScoringDetails = React.forwardRef<HTMLDivElement, Props>(
    function ScoringDetails(props, ref) {
        if (props.scoringDetails) {
            return (
                <Box ref={ref} sx={{ p: 1, bgcolor: '#F6F8F9', mr: -2 }}>
                    <ScoreBreakDown scoreDetails={props.scoringDetails} />
                </Box>
            );
        } else {
            return null;
        }
    }
);

export default ScoringDetails;
